const Aside = ({ emailValue, handleClick }) => {

    const successBtnClick = () => {
        handleClick();
    }

    return ( 
        <aside className="success">
            <div className="success-img">

            </div>
            <h2>Thanks for subscribing!</h2>
            <p>A confirmation email has been sent to {emailValue}. please open it and click the button inside to confirm your subscription</p>
            <button className="btn" onClick={successBtnClick}>Dismiss message</button>
        </aside>
     );
}
 
export default Aside;